"use client";
import React from "react";

interface Props {
  text: string;
}

const CategoryDescriptionToggle = ({ text }: Props) => {
  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-5 mb-6 shadow-sm">
      <p
        className="text-slate-500 text-sm leading-relaxed m-0"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {text}
      </p>
      <a
        href="#category-full-description"
        className="mt-2 inline-block text-[11px] font-black text-blue-600 uppercase tracking-widest hover:text-[#D61C4E] transition-colors no-underline"
      >
        See More
      </a>
    </div>
  );
};

export default CategoryDescriptionToggle;
